import React from 'react';
import { TableData } from '../../pages/askFreya/types';

export const RichTable: React.FC<{ data: TableData }> = ({ data }) => {
  return (
    <div className='w-full overflow-hidden border border-neutral-20 rounded-16 bg-white my-16 shadow-sm font-inter'>
      {data.title && (
        <div className='px-20 py-16 border-b border-neutral-20'>
          <h3 className='text-16 font-semibold text-neutral-90'>{data.title}</h3>
        </div>
      )}
      <div className='overflow-x-auto'>
        <table className='w-full text-14 text-left'>
          <thead className='text-12 text-neutral-90 font-bold bg-neutral-5 border-b border-neutral-20'>
            <tr>
              {data.headers.map((header) => (
                <th key={header} className='px-24 py-16 font-bold text-neutral-90'>
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className='divide-y divide-neutral-20'>
            {data.rows.map((row, rowIndex) => (
              // eslint-disable-next-line react/no-array-index-key
              <tr key={rowIndex} className='bg-white hover:bg-neutral-5'>
                {data.headers.map((header) => (
                  <td key={`${rowIndex}-${header}`} className='px-24 py-16 whitespace-nowrap text-neutral-90'>
                    {row[header]}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
